import { Controller } from "@hotwired/stimulus"

// Sign-up account-type toggle (فردی/حقوقی): slides a highlight pill behind
// the selected option and swaps the national_id field's label to match.
export default class extends Controller {
  static targets = ["pill", "option", "nationalIdLabel"]
  static values = {
    individualLabel: String,
    corporateLabel: String
  }

  connect() {
    this.movePill()
    this.resizeHandler = () => this.movePill()
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
  }

  toggle() {
    this.movePill()
    this.updateNationalIdLabel()
  }

  movePill() {
    const checked = this.checkedOption
    if (!checked) return
    const label = checked.closest("label")
    const containerRect = this.pillTarget.parentElement.getBoundingClientRect()
    const labelRect = label.getBoundingClientRect()
    this.pillTarget.style.width = `${labelRect.width}px`
    this.pillTarget.style.transform = `translateX(${labelRect.left - containerRect.left}px)`
  }

  updateNationalIdLabel() {
    const checked = this.checkedOption
    if (!checked) return
    const text = checked.value === "corporate" ? this.corporateLabelValue : this.individualLabelValue
    this.nationalIdLabelTarget.querySelector("label").textContent = text
  }

  get checkedOption() {
    return this.optionTargets.find((option) => option.checked)
  }
}
